var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../ListView/listView.scss";
import "./mapOrdersPage.scss";
import { postDraftStatus } from "../../api/venues";
import { useUserInfo } from "../../hooks";
import { CHECKED_IN_NOTIFICATION, fallBackMapOrderList, EMPTY_MAP_ORDER_LIST, MAP_ORDERS_TABLE_HEADERS, } from "./constants";
import { MAP_STATUS, NOTIFICATION_VARIANT, API_STATUS_CODE, } from "../../store/common/constants";
import utils from "../../store/helpers/indoorHelper";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { HDSTooltip } from "@here/hds-react-components/Tooltip";
import { HDSChip } from "@here/hds-react-components/Chip";
import { chipStyles, copyIconStyle, MAP_ORDER_ACTIONBUTTONS, } from "./constants";
import { copyMapId, copyText, downloadAttributeQAReport, handleEdit, } from "./helper";
import { Table, Text } from "../../generic-components/Table";
import { ENVIRONMENT } from "../../store/common/constants";
import { toast } from "@here/hds-notification";
import translations from "../../translations/resources/en-GB.json";
import { ConfirmDailog } from "../../generic-components";
import { ConfirmBody } from "../../features/venueDetails/confirm-body";
var MapOrdersPage = memo(function () {
    var mapOrdersMetaList = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.mapOrdersMetaList; });
    var dispatch = useDispatch();
    var _a = mapOrdersMetaList || fallBackMapOrderList, isLoading = _a.isLoading, _b = _a.mapOrderList, mapOrderList = _b === void 0 ? [] : _b;
    var _c = useState([]), mapList = _c[0], setMapList = _c[1];
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    //TODO: we have to remove useRef, this can be handled by lift the state up to parent component
    var selectedHrns = useRef({ list: [] });
    var token = useUserInfo().token;
    var hostName = utils.isNotPrd(window.location.hostname)
        ? ENVIRONMENT.SIT.DOMAIN
        : window.location.hostname;
    //shared drafts to be checked in
    var checkInNewOrderMap = function (hrn) { return __awaiter(void 0, void 0, void 0, function () {
        var title, body, res, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    title = CHECKED_IN_NOTIFICATION.title, body = CHECKED_IN_NOTIFICATION.body;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postDraftStatus(token, hrn, MAP_STATUS.CHECKED_IN.VALUE)];
                case 2:
                    res = _a.sent();
                    if (res.status === API_STATUS_CODE.REQUEST_ACCEPTED) {
                        removeItemFromMapList();
                        utils.notify(title, body, 2, NOTIFICATION_VARIANT.CONFIRM, "solid");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setMapList(__spreadArray([], mapOrderList, true));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var removeItemFromMapList = function () {
        var selectedHrnList = selectedHrns.current.list;
        var updatedList = mapList.filter(function (d) { return !selectedHrnList.includes(d.hrn); });
        setMapList(__spreadArray([], updatedList, true));
    };
    var handleCheckIn = function (selectedList) {
        var clonedlist = structuredClone(mapList);
        var filteredList = clonedlist.map(function (item) {
            if (!item.isCheckInDisabled) {
                if (item.supportTicketNumber === selectedList.supportTicketNumber) {
                    item.isCheckInDisabled = true;
                }
            }
            return item;
        });
        var currentSelectedList = selectedHrns.current.list;
        selectedHrns.current.list = __spreadArray(__spreadArray([], currentSelectedList, true), [selectedList.hrn], false);
        setMapList(__spreadArray([], filteredList, true));
        checkInNewOrderMap(selectedList.hrn);
    };
    //this will update the local state to list the map order data
    useEffect(function () {
        var ignore = false;
        if (!ignore) {
            var clonedList = structuredClone(mapOrderList);
            setMapList(__spreadArray([], clonedList, true));
        }
        return function () {
            ignore = true;
        };
    }, [mapOrderList.length]);
    var cells = {
        mapName: function (item) { return (_jsxs("div", __assign({ className: "mapUUIDName" }, { children: [_jsx("div", __assign({ "data-testid": "copy-icon", onClick: function () {
                        copyMapId(item.mapId);
                    }, id: "".concat(CSS.escape(item.mapId), "-name"), className: "copyMapId" }, { children: item.mapId && (_jsx(HDSIcon, { name: "map-planner", category: "tools", iconStyle: "outline", size: "16px", style: copyIconStyle })) })), _jsx(HDSTooltip, __assign({ trigger: "#".concat(CSS.escape(item.mapId), "-name"), placement: "left" }, { children: item.mapId })), _jsx(Text, { classes: "mapOrderName", value: item.mapName })] }))); },
        organizationId: function (item) { return (_jsx(Text, { classes: "mapOrderCustomer", value: item.organizationId })); },
        org: function (item) { return (_jsx("div", __assign({ className: "mapOrderOrg" }, { children: _jsx(HDSChip, __assign({ size: "small", style: chipStyles }, { children: item.org })) }))); },
        supportTicketNumber: function (item) { return (_jsxs("div", __assign({ className: "mapOrderServiceTicket" }, { children: [_jsxs("div", __assign({ className: "collectionUrl", "data-testid": "copy-icon", id: item.supportTicketNumber, onClick: function () {
                        copyText(item.supportTicketNumber);
                    } }, { children: [_jsx(HDSButton, __assign({ variant: "link" }, { children: item.supportTicketNumber })), item.supportTicketNumber && (_jsx(HDSIcon, { name: "copy", category: "file", size: "16px", style: copyIconStyle }))] })), _jsx(HDSTooltip, __assign({ trigger: "#".concat(item.supportTicketNumber), placement: "right" }, { children: item.supportTicketNumber }))] }))); },
        isCheckInDisabled: function (item) { return (_jsxs("div", __assign({ className: "map_action_buttons_layout" }, { children: [_jsx("div", __assign({ className: "map_actions_container", onClick: function () { return handleCheckIn(item); } }, { children: _jsx(HDSButton, __assign({ size: "small", variant: "secondary", disabled: item.isCheckInDisabled, width: "85px" }, { children: MAP_ORDER_ACTIONBUTTONS.CHECK_IN })) })), _jsx("div", __assign({ className: "", onClick: function () { return handleEdit(hostName, item.hrn); } }, { children: _jsx(HDSButton, __assign({ size: "small", variant: "primary" }, { children: MAP_ORDER_ACTIONBUTTONS.EDIT })) })), _jsxs("div", __assign({ className: "attrQAReport" }, { children: [_jsx("div", __assign({ className: "collectionUrl", "data-testid": "copy-icon", id: item.mapId, onClick: function () {
                                return dispatch(downloadAttributeQAReport(item.hrn, item.mapId, toast, setShowModal));
                            } }, { children: item.mapId && (_jsx(HDSIcon, { name: "dataset", category: "misc", size: "24px" })) })), _jsx(HDSTooltip, __assign({ trigger: "#".concat(item.mapId), placement: "right" }, { children: translations.data["venonboard.internalTools.buttonAttributeQAReport"] }))] }))] }))); },
    };
    return (_jsxs(_Fragment, { children: [showModal && (_jsx(ConfirmDailog, { header: translations.data["venonboard.internalTools.buttonAttributeQAReport"], hideCloseBtn: true, renderBody: function () { return _jsx(ConfirmBody, {}); } })), _jsx("div", __assign({ className: "mapOrdersMapCount" }, { children: (mapList === null || mapList === void 0 ? void 0 : mapList.length) > 0 ? "".concat(mapList === null || mapList === void 0 ? void 0 : mapList.length, " maps") : "" })), _jsx("div", __assign({ className: "collectionBox" }, { children: _jsx(Table, { columns: MAP_ORDERS_TABLE_HEADERS, rows: mapList, cells: cells, fallbackComponent: EmptyMapOrderList, isLoading: isLoading && utils.isEmpty(mapList) }) }))] }));
});
export default MapOrdersPage;
var EmptyMapOrderList = (_jsx("div", __assign({ className: "empty-result" }, { children: _jsx("b", { children: EMPTY_MAP_ORDER_LIST }) })));
